type Props = {
  provider: string
  code: string
}
export function OAuthLoginPage({ provider: _provider, code: _code }: Props) {
  return <div />
}
